// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsQuotedPricingStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuotedPricing";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsQuotedPricingStyles.quantityCell = {
    css: css`
        border: none;
        height: 30px;
        vertical-align: top;
        min-width: auto;
        ${xScreen("lte", 767)} {
            padding: 0 8px 0 0;
        }
    `,
};

rfqQuoteDetailsQuotedPricingStyles.priceCell = {
    css: css`
        border: none;
        height: 30px;
        min-width: auto;
        ${xScreen("lte", 767)} {
            padding: 0 8px;
        }
    `,
};
